import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import {
  selectA2CFrequentlyBoughtRecommendations,
  selectA2CFrequentlyBoughtRecommendationsConfig,
} from '@/domains/shoppingCart/AddToCart/selectors/recommendations';
import type { SpartacuxShoppingCartState } from '@/domains/shoppingCart/ShoppingCartState';

import type { ProcessedRecommendationItem } from '../../interfaces/msRecommendation';
import type { RecommendationPlaylist } from '../../interfaces/productRecommendation';

interface Engine {
  recoEngineConfigSelector: (
    state: Partial<SpartacuxShoppingCartState>,
  ) => ProcessedRecommendationItem | undefined;
  recoEngineSelector: (
    state: Partial<SpartacuxShoppingCartState>,
  ) => RecommendationPlaylist | undefined;
  recoEngineConfig: ProcessedRecommendationItem | undefined;
}

export const useSelectA2cFBTEngine = (): Engine => {
  const selectA2CFrequentlyBoughtRecommendationsSelector = useCallback(
    (
      state: Partial<
        SpartacuxProductDiscoveryDomainState & SpartacuxShoppingCartState
      >,
    ) => selectA2CFrequentlyBoughtRecommendations(state),
    [],
  );

  const recoEngineConfigSelector =
    selectA2CFrequentlyBoughtRecommendationsConfig;
  const recoEngineConfig = useSelector(recoEngineConfigSelector);

  return {
    recoEngineConfig,
    recoEngineSelector: selectA2CFrequentlyBoughtRecommendationsSelector,
    recoEngineConfigSelector,
  };
};
